import { getOffset } from '../../../../libs/paging';
import { LIMIT } from '../../../../libs/paging/constant';
import { InstagramHashtagFeedPostListProps } from './index';

export const allInstagramHashtagPostsVariables = (props: InstagramHashtagFeedPostListProps) => {
  const {
    currentPage,
    filter: { keyword, period },
    sort: { field, order },
    hashtagId
  } = props;

  return {
    hashtagId,
    offset: getOffset(currentPage),
    limit: LIMIT,
    keyword,
    orderBy: { field, order },
    startDate: period.startDate,
    endDate: period.endDate
  };
};
